/* Types */
import { Mode } from '../types/main'

/**
 * Получаем cdn url в зависимости от окружения
 * @param mode - текущий env окружения
 * @param pipelineId - сгенерированный id в pipeline build
 */
export const getCdnURl = (
  mode: string | undefined,
  pipelineId: string | undefined,
) => {
  /* В development режиме статика локально */
  if (!mode || !pipelineId || mode === Mode.DEVELOPMENT) return ''

  let cdnUrl = ''

  switch (mode) {
    case Mode.BRANCH:
      cdnUrl = 'https://storage.yandexcloud.net/cdn-dev/site-frontend'
      break

    case Mode.STAGING:
      cdnUrl = 'https://static.frfrstaging.ru/site-frontend'
      break

    case Mode.RC:
      cdnUrl = 'https://static.farfor-rc.ru/site-frontend'
      break

    case Mode.RELEASE:
      cdnUrl = 'https://static.farfor.ru/site-frontend'
      break
  }

  // Проверка на всякий случай
  if (cdnUrl) cdnUrl = `${cdnUrl}/${pipelineId}/`

  return cdnUrl
}
